import { Component } from '@angular/core';

@Component({
    selector: 'app-terms-of-service',
    imports: [],
    templateUrl: './terms-of-service.component.html',
    styleUrl: './terms-of-service.component.css'
})
export class TermsOfServiceComponent {
mail='info@resiliencesoft.com'
}
